import { Component, Input, OnInit } from '@angular/core';
import { Company } from 'src/app/lem/models/companies/company';
import { Output, EventEmitter } from '@angular/core';
import { Role } from 'src/app/lem/models/common/role';
import { PaginatedResponse } from 'src/app/lem/models/common/paginated-response';
import { Pagable } from 'src/app/lem/models/common/pagable';
import { Pagination } from 'src/app/common/models/pagination';

@Component({
  selector: 'app-ruoli-list',
  templateUrl: './ruoli-list.component.html',
  styleUrls: ['./ruoli-list.component.css']
})
export class RuoliListComponent implements OnInit {

  @Input() resetCurrentPage: boolean;
  @Input() roles : PaginatedResponse<Role>;
  @Output() edit = new EventEmitter<Role>();
  @Output() delete = new EventEmitter<Role>();
  @Input() pagable:Pagable;
  @Output() refreshEvent: EventEmitter<Pagination> = new EventEmitter<Pagination>();

  constructor() { }



  ngOnInit() {

  }

  onEdit(role : Role) {
    this.edit.emit(role);
  }
  onDelete(role : Role) {
    this.delete.emit(role);
  }
  onInfo(role : Role) {

  }

}
